import store from "../../store/store"
import { ProjectSettingsHub } from "../hubs/projectSettings"

export const projectSettingsHub = new ProjectSettingsHub(store)
